import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { NavigationService } from '../navigation.service';
import { UserService } from '../user.service';
import {Observable} from 'rxjs';
import {filter, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserMailVerifiedGuardService  {

  constructor(private router: Router, private userService: UserService, private navigationService: NavigationService ) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): boolean | Observable<boolean> {

      console.log('MailVerifiedGuard reached!', route, state);
      // This tells the navigation service where the user actually wanted to go.
      // This line would be more logic in the AuthGuard, but it goes AuthGuard --> MailVerifiedGuard --> AuthGuard
      // where the last AuthGuard points to the mail not verified page which would be wrong. Therefore, this line must be here.
      this.navigationService.requestedPageRoute = state.url;

      // in case user service is ready and mail is verified, return true
      if (this.userService.serviceReady && this.userService.user.emailVerified)  {
        return true;
      }
      // in case user service is not ready yet, wait for it and then check email verified
      if (!this.userService.serviceReady) {
          return this.userService.serviceReadySubject.asObservable().pipe(
              filter(val => val),
              tap(val => {
                  if (!val) { return false; }
                  return this.userService.user.emailVerified;
              }));
      }

      this.router.navigate(['email-not-verified-yet']).then();
      console.log('Router should now navigate to email-not-verified-yet');
      return false;
  }
}
